import React, { useState } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { profile } from '../../data/profile';
import { EASE_OUT } from '../../utils/motion';
const POLAROID_HIDDEN = {
  x: 6,
  y: 56,
  rotate: -3,
  scale: 0.66,
  opacity: 0
};
const POLAROID_SHOWN = {
  x: -6,
  y: -30,
  rotate: -9,
  scale: 1,
  opacity: 1
};
const TRANSITION = {
  duration: 0.3,
  ease: EASE_OUT
};

/**
 * Hero portrait. Hovering (or focusing / tapping) pops the talk photo out from behind the
 * bottom-left corner as a small instant-print, settling at a playful angle over the portrait.
 */
export function PortraitPolaroid() {
  const [open, setOpen] = useState(false);
  const reduce = useReducedMotion();
  return <div className="relative cursor-pointer select-none focus-visible:outline-none" tabIndex={0} role="button" aria-pressed={open} aria-label="Show a photo of Kat speaking at Universidad EAFIT" onPointerEnter={e => e.pointerType === 'mouse' && setOpen(true)} onPointerLeave={e => e.pointerType === 'mouse' && setOpen(false)} onPointerUp={e => {
    // Touch has no hover, so a tap toggles the print instead.
    if (e.pointerType !== 'mouse') setOpen(v => !v);
  }} onFocus={e => {
    // Only keyboard focus opens it; a tap's focus would otherwise fight the tap toggle.
    if (e.currentTarget.matches(':focus-visible')) setOpen(true);
  }} onBlur={() => setOpen(false)} onKeyDown={e => {
    if (e.key === 'Escape') setOpen(false);
  }} data-id="element-287" data-mp="tgn30zjdr4xe">
      <img src={profile.portrait} alt={profile.portraitAlt} className="relative z-[1] aspect-[4/5] w-full rounded-3xl object-cover object-[center_60%] shadow-[0_12px_32px_rgba(27,34,32,0.10)]" data-id="element-288" data-mp="2xppoonsrhdq6" />

      <motion.span aria-hidden className="pointer-events-none absolute right-3 top-3 z-[2] inline-flex items-center gap-1.5 rounded-full bg-white/95 px-2.5 py-1.5 text-[11px] font-semibold text-ink shadow-[0_6px_16px_rgba(27,34,32,0.12)]" initial={false} animate={open ? {
      opacity: 0,
      y: -4
    } : {
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.18,
      ease: EASE_OUT
    }} data-id="element-289" data-mp="3lh4votvhgj7r">
        <span className="h-1.5 w-1.5 rounded-full bg-coral" data-id="element-290" data-mp="2n5237wnn05w4" />
        psst, hover me
      </motion.span>

      <motion.div aria-hidden={!open} className="pointer-events-none absolute -bottom-6 -left-10 z-[3] w-[150px] origin-bottom-left rounded-md bg-white px-2.5 pb-3 pt-2.5 shadow-[0_22px_40px_rgba(27,34,32,0.26),0_2px_6px_rgba(27,34,32,0.08)] [will-change:transform,opacity]" initial={false} animate={open ? POLAROID_SHOWN : POLAROID_HIDDEN} transition={reduce ? {
      duration: 0.15
    } : TRANSITION} data-id="element-291" data-mp="2rwjzw8imnkba">
        <span aria-hidden className="absolute -top-2 left-1/2 h-4 w-8 -translate-x-1/2 -rotate-6 rounded-sm border border-coral/35 bg-[#F9E4DE]/90 shadow-[0_3px_6px_rgba(27,34,32,0.15)]" data-id="element-292" data-mp="3aud2f9pc9s85" />
        <div className="aspect-[4/4.6] overflow-hidden rounded-sm bg-[#111]" data-id="element-293" data-mp="1giycarsf1qrv">
          <img src={profile.talkPhoto} alt={profile.talkPhotoAlt} loading="eager" className="h-full w-full object-cover object-[center_30%] grayscale" data-id="element-294" data-mp="18yx8vs5yo2en" />
        </div>
        <p className="mt-2 -rotate-1 text-center text-[15px] leading-tight text-[#1E4B48]" style={{
        fontFamily: "'Caveat', 'Bradley Hand', cursive"
      }} data-id="element-295" data-mp="v67lpkep4rfy">
          Speaking at EAFIT · <span className="font-bold text-[#E5634D]" data-id="element-296" data-mp="1mxdok8lsx38x">Magic Patterns ambassador</span>
        </p>
      </motion.div>
    </div>;
}